module.exports = __webpack_public_path__ + "img/1483545385.ba868068.jpg";